import "./NavBar.css";
import { useNavigate } from "react-router-dom";

function NavBar()
{
    const nav = useNavigate();

    const client_id = "KSbWqdAY~v6AxY0t";

    function openHome()
    {
        nav("/");
    }

    function openTeam()
    {
        nav("/team");
    }

    function dauthLogin()
    {
        window.location.href = "https://auth.delta.nitt.edu/authorize?client_id=" + client_id + "&redirect_uri=https://favprod.raganindustries.com&response_type=code&grant_type=authorization_code&scope=openid+email+profile+user";
    }

    return(
        <>
            <div className = "desktop">
                <div className = "navbar">
                    <div className = "spacer" style = {{ width : '7.5%' }} ></div>
                    <img src = "/Logos/Festember_Logo.png" alt = "err" className = "festember_logo" />
                    <h1 className = "title" >ESTEMBER</h1>
                    <div className = "spacer" style = {{ width : '10%' }} ></div>
                    <div className = "home">
                        <img src = "/Icons/Home.png" alt = "err" className = "home_icon" />
                        &emsp;&nbsp;&nbsp;
                        <h1 onClick = { openHome }>Home</h1> 
                    </div>
                    <div className = "spacer" style = {{ width : '2.5%' }} ></div>
                    <div className = "register">
                        <img src = "/Icons/Register.png" alt = "err" className = "register_icon" />
                        &emsp;&nbsp;&nbsp;
                        <h1 onClick = { dauthLogin } >Induction</h1> 
                    </div>
                    <div className = "spacer" style = {{ width : '2.5%' }} ></div>
                    <div className = "team">
                        <img src = "/Icons/Team.png" alt = "err" className = "team_icon" />
                        &emsp;&nbsp;&nbsp;
                        <h1 onClick = { openTeam }>Team</h1> 
                    </div>
                    <div className = "spacer" style = {{ width : '30%' }} ></div>
                    <button className = "login">Login</button>
                </div>
            </div>
            <div className = "mobile">
                <div className = "navbar">
                    <div className = "spacer" style = {{ width : '4%' }} ></div>
                    <img src = "/Logos/Festember_Logo.png" alt = "err" className = "festember_logo" />
                    <div className = "spacer" style = {{ width : '15%' }} ></div>
                    <div className = "home">
                        <img onClick = { openHome } src = "/Icons/Home.png" alt = "err" className = "home_icon" />
                    </div>
                    <div className = "spacer" style = {{ width : '5%' }} ></div>
                    <div className = "register">
                        <img onClick = { dauthLogin } src = "/Icons/Register.png" alt = "err" className = "register_icon" />
                    </div>
                    <div className = "spacer" style = {{ width : '5%' }} ></div>
                    <div className = "team">
                        <img onClick = { openTeam } src = "/Icons/Team.png" alt = "err" className = "team_icon" />
                    </div>
                    <div className = "spacer" style = {{ width : '15%' }} ></div>
                    <button className = "login">Login</button>
                </div>
            </div>
        </>
    );

}

export default NavBar;